import { Injectable } from '@angular/core';
import { LocalStorageManager } from '@examdojo/browser/local-storage';

const DISMISSED_STORAGE_KEY = 'banner-dismissed';

type DismissedState = Record<string, true>;

@Injectable()
export class BannerStorageService {
  private readonly storage = new LocalStorageManager<DismissedState>(DISMISSED_STORAGE_KEY);

  isDismissed(message: string): boolean {
    const key = this.toStorageKey(message);
    return this.storage.getValue()?.[key] === true;
  }

  dismiss(message: string): void {
    const key = this.toStorageKey(message);
    const state = this.storage.getValue() ?? {};
    state[key] = true;
    this.storage.setValue(state);
  }

  private toStorageKey(str: string): string {
    return btoa(encodeURIComponent(str));
  }
}
